<template>
    <div>
        <div class="designeroption" id="frame_style" data-designer-component-id="side_panels">
            <h3>Side Panels &amp; Top Lights</h3>
            <div class="activatepanels" v-show="isFiredoor">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the switches on the right, once activated your choice will highlight blue.</p>
                    <p>Once you select a sidepanel further options will be available.</p>
                </div>

                <div :class="['options', sideIsChecked('right') ? 'disabled-left' : '', sideIsChecked('left') ? 'disabled-right' : '']">
                    <div class="topbox topboxfire">
                        <input type="checkbox" value="top" v-model="target.checkedPanels"/>
                    </div>
                    <div class="sidepanels">
                        <div class="leftpanel">
                            <input type="checkbox" value="left" class="left" v-model="target.checkedPanels" :disabled="sideIsChecked('right')"/>
                        </div>
                        <img :src="'/images/activatepanelsimg.png'" alt="" class="doorimg"/>
                        <div class="rightpanel">
                            <input type="checkbox" value="right" class="right" v-model="target.checkedPanels" :disabled="sideIsChecked('left')"/>
                        </div>
                    </div>
                </div>
                <div class="switches">
                    <div class="switchbox">
                        <p>Top</p>
                        <input type="checkbox" value="top" v-model="target.checkedPanels"/>
                        <span class="status" v-text="sideIsChecked('top') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox" v-show="!sideIsChecked('right')">
                        <p>Left</p>
                        <input type="checkbox" value="left" v-model="target.checkedPanels" :disabled="sideIsChecked('right')"/>
                        <span class="status" v-text="sideIsChecked('right') ? 'Not Available with right sidelight' : sideIsChecked('left') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox" v-show="sideIsChecked('right')">
                        <p>Left</p>
                        <span class="status">Not Available with right sidelight</span>
                    </div>
                    <div class="switchbox" v-show="!sideIsChecked('left')">
                        <p>Right</p>
                        <input type="checkbox" value="right" v-model="target.checkedPanels" :disabled="sideIsChecked('left')"/>
                        <span class="status" v-text="sideIsChecked('left') ? 'Not Available with left sidelight' : sideIsChecked('right') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox" v-show="sideIsChecked('left')">
                        <p>Right</p>
                        <span class="status">Not Available with left sidelight</span>
                    </div>
                </div>
            </div>

            <div class="activatepanels" v-show="!isFiredoor">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the switches on the right, once activated your choice will highlight blue.</p>
                    <p>Once you select a side & top light further options will be available.</p>
                </div>
                <div class="options">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="target.checkedPanels"/>
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="target.checkedPanels" />
                        <img :src="'/images/activatepanelsimg.png'" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="target.checkedPanels"/>
                    </div>
                </div>

                <div class="switches">
                    <div class="switchbox">
                        <p>Top</p>
                        <input type="checkbox" value="top" v-model="target.checkedPanels" />
                        <span class="status" v-text="sideIsChecked('top') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox">
                        <p>Left</p>
                        <input type="checkbox" value="left" v-model="target.checkedPanels" />
                        <span class="status" v-text="sideIsChecked('left') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox">
                        <p>Right</p>
                        <input type="checkbox" value="right" v-model="target.checkedPanels" />
                        <span class="status" v-text="sideIsChecked('right') ? 'On' : 'Off'"></span>
                    </div>
                </div>
            </div>
        </div>

        <hallmark-designer-question-frame-style :fabricator="fabricator" :type-range="typeRange" :is-firedoor="isFiredoor" :frame-material="isFiredoor ? 3 : 1" :title="title" v-model:target="target.frame_id" :checked-panels="target.checkedPanels">

        </hallmark-designer-question-frame-style>
    </div>
</template>


<style>
    .side-panels .panel_check { opacity:1!important }
    .side-panels span { margin-left:30px; font-weight:normal; }
    .side-panels label:hover { cursor:pointer; }
</style>


<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameStyle from "../DesignerQuestionSelectFrameStyle.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameStyle
        ],
        props: {
            isFiredoor: {
                required: true
            },
            typeRange: {
                required: true
            }
        }
    }
</script>
